<div class="card p-12" #webexWidget>
    <div class="card-body">
        <div style="display:flex; justify-content: space-between">
            <div class="rounded float-start" width="50">
                <mat-icon class="s-28" id="webex-notification-icon"
                 style="display: none; color: var(--theme-accent-color-600)">notifications</mat-icon>
            </div>
            <!-- <img src="../../../assets/images/webex-by-cisco-logo-vertical-colour.png" class="rounded float-start" width="50" /> -->
            <div style="display:flex;">

                <button mat-icon-button class="mx-4" (click)="onMinimize()" *ngIf="!isMinimized">
                    <mat-icon class="s-20">horizontal_rule</mat-icon>
                </button>                

                <button mat-icon-button class="mx-4" (click)="onResetSize()" *ngIf="!isExpanded && isMinimized">
                    <mat-icon class="s-20">expand_less</mat-icon>
                </button>

                <button mat-icon-button class="mx-4" (click)="onExpand()" *ngIf="!isExpanded">
                    <mat-icon class="s-20">open_in_full</mat-icon>
                </button>
    
                <button mat-icon-button class="mx-4" (click)="onResetSize()" *ngIf="isExpanded && !isMinimized">
                    <mat-icon class="s-20">close_fullscreen</mat-icon>
                </button>

                <button mat-icon-button class="mx-4" (click)="onClose()">
                    <mat-icon class="s-20">close</mat-icon>
                </button>
            </div>
        </div>
        
        <div class="card-title p-4">
            <div class="text-center"></div> <!--Webex Integration-->
            <br>
        </div>
        <div class="card-text">
            <div>
                <div id="webex-widget" [class]="'webex-space-widget'"></div>
            </div><!--loginMethod === 'User'? 'webex-recents-widget' : -->
            <div>
                <div id="space" style="width: 700px; height: 300px; margin-left: 300px;"></div>
            </div>
        </div>
    </div>
</div>   